import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class TwoFactor extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "isActive", Model.attribute('isActive'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
  }
}
flarum.reg.add('ianm-twofactor', 'common/models/TwoFactor', TwoFactor);